import { Select } from 'src/design/atoms/Select';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { JobDto } from 'src/api/FiretrolApiClient';
import { useJobs } from 'src/hooks/useJobs';

export interface IJobSelectorProps {
  onChange?: (job: JobDto) => void;
}

const isTouchDevice = () =>
  typeof window !== 'undefined' &&
  ('ontouchstart' in window || navigator.maxTouchPoints > 0);

/** @registry Select dropdown for switching the currently active job. */
export const JobSelector: React.FC<IJobSelectorProps> = ({ onChange }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedJob, jobs } = useJobs();
  const inputRef = React.useRef<HTMLInputElement>(null);

  const data = React.useMemo(
    () =>
      jobs.map((job) => ({
        value: String(job.id),
        label: `${job.jobNumber} - ${job.name}`,
      })),
    [jobs],
  );

  const selectedValue =
    location.pathname === '/activity' || !selectedJob
      ? null
      : String(selectedJob.id);

  const handleOptionSubmit = (value: string) => {
    const selectedJobObj = jobs.find((job) => String(job.id) === value);
    if (selectedJobObj) {
      if (onChange) onChange(selectedJobObj);
      navigate(`/jobs/${selectedJobObj.id}/summary`);
    }
  };

  const handleFocus = () => {
    if (!isTouchDevice()) {
      inputRef.current?.select();
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <Select
        ref={inputRef}
        placeholder="Quick Navigation"
        data={data}
        value={selectedValue}
        onOptionSubmit={handleOptionSubmit}
        onFocus={handleFocus}
        searchable
        clearable={false}
        allowDeselect={false}
      />
    </div>
  );
};
